module.exports = __webpack_public_path__ + "static/media/sTar.d5550d19.png";